import {AssetsRequestParams} from "../../../../../../../infrastructure/models/params/assets-request-params";
import {IMAGE_DEFAULT_FORMATS} from "../../../../../../../core/app/consts";

export class PlayerStatisticsTableRowValueRequestParams extends AssetsRequestParams {
  constructor(type: String) {
    super();

    this.resourceName = `${this.resourceName}/BoxScorePlayerStatistics/${type}`;
    this.version = 3;
  }

  get defaultFormat(): String {
    return IMAGE_DEFAULT_FORMATS.SVG;
  }
}
